<template>
    <div class="container mt-4">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="card">
                    <div class="card-header">
                        {{ $t('auth.reset_password.header') }}
                    </div>

                    <div class="card-body">
                        <validation-errors :errors="errors" v-if="errors" />
                        <form-status :status="status" v-if="status" />

                        <form @submit.prevent="resetPassword">

                            <div class="form-group row">
                                <label for="password" class="col-md-4 col-form-label text-md-right">{{ $t('auth.password') }}</label>

                                <div class="col-md-6">
                                    <input id="password" type="password" class="form-control" required autocomplete="new-password" v-model="password">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="password-confirm" class="col-md-4 col-form-label text-md-right">{{ $t('auth.confirm_password') }}</label>

                                <div class="col-md-6">
                                    <input id="password-confirm" type="password" class="form-control" required autocomplete="new-password" v-model="password_confirmation">
                                </div>
                            </div>

                            <div class="form-group row mb-0">
                                <div class="col-md-6 offset-md-4">
                                    <button type="submit" class="btn btn-primary" :disabled="loading">
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                                        {{ $t('auth.reset_password.submit') }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ValidationErrors from '@components/ValidationErrors';
    import FormStatus from '@components/FormStatus';
    import BackofficeRepository from '@/repositories/BackofficeRepository';
    import backofficeMapsRepository from '@repositories/BackofficeMapsRepository';
    import toastr from 'toastr';

    export default {
        components: {
            ValidationErrors,
            FormStatus,
        },

        data() {
            return {
                password: '',
                password_confirmation: '',
                errors: [],
                status: null,
                token: this.$route.params.token,
                loading: false,
            };
        },

        methods: {
            async resetPassword() {
                this.errors = [];
                this.loading = true;
                try {
                    //validate password confirmation
                    if(this.password !== this.password_confirmation){
                        this.errors = [this.$t('validation.passwords_have_to_be_same')];
                        this.loading = false;
                        return;
                    }

                    const response = await BackofficeRepository.resetUserPassword(this.token, this.password);
                    if(response.data.resetUserPassword){
                        //success toastr message and redirect to login page
                        toastr.success(this.$t('auth.reset_password.password_changed'));
                        this.$router.push({ name: 'login.index' });
                    }
                    else{
                        this.errors = backofficeMapsRepository.parseAPIError(response);
                    }
                } catch (error) {
                    this.errors = [backofficeMapsRepository.parseAPIError(error)];
                }
                finally {
                    this.loading = false;
                }
            },
        },
    };
</script>
